<template>
  <section class="section" id="contact">
    <br>
    <br>
    <div class="container">
      <img class="b-title" :src="require(`../assets/titles/${$i18n.locale}/contact.jpg`)" alt="Kontakt">
      <b-divider></b-divider>
      <br>
      <div class="columns is-mobile">
        <div class="column has-text-right">
          <p>Jederzeit <span class="is-hidden-mobile">telefonisch</span> erreichbar</p>
          <p>+49 721 94246 - 0</p>
        </div>
        <div class="column is-narrow">
          <fal class="fa-3x">
            <fa class="has-text-orange" icon="square-full"></fa>
            <fa class="has-text-white" icon="phone" transform="shrink-8"></fa>
          </fal>
        </div>
        <div class="column is-narrow">
          <fal class="fa-3x">
            <fa class="has-text-orange" icon="square-full"></fa>
            <fa class="has-text-white" icon="envelope" transform="shrink-8"></fa>
          </fal>
        </div>
        <div class="column">
          <p>Ganz bequem per Email</p>
          <p>info@bringe.com</p>
        </div>
      </div>
      <div class="b-line"></div>
      <br>
      <div class="columns is-mobile">
        <div class="column has-text-right">
          <p>Haben Sie eine Frage an unsere Buchhaltung</p>
          <p>buchhaltung@bringe.com</p>
        </div>
        <div class="column is-narrow">
          <fal class="fa-3x">
            <fa class="has-text-orange" icon="square-full"></fa>
            <fa class="has-text-white" icon="fax" transform="shrink-8"></fa>
          </fal>
        </div>
        <div class="column is-narrow">
          <fal class="fa-3x">
            <fa class="has-text-orange" icon="square-full"></fa>
            <fa class="has-text-white" icon="map-marker-alt" transform="shrink-8"></fa>
          </fal>
        </div>
        <div class="column">
          <p>Rudolf-Link-Strasse 6</p>
          <p>76228 Karlsruhe</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BDivider from '@/components/BDivider.vue';

export default {
  name: 'BContact',
  components: {
    BDivider,
  },
}
</script>

<style lang="scss" scoped>
  @import "../styles/variables";

  .b-title {
    width: 140px;
  }

  .container {
    max-width: 100%;
  }

  #contact {
    padding-left: 0;
    padding-right: 0;
    .b-map {
      margin-left: -50px;
      margin-right: -50px;
    }
    iframe {
      width: 100%;
      margin-right: auto;
      margin-left: auto;
      min-height: 500px;
      pointer-events: none;
    }
  }

  .b-line {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    height: 1px;
    border-top: thin dashed $grey-light;
  }
</style>
